import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

export class DropDown extends React.Component {
  render() {
    const {
      className,
      options,
      value,
      onChange,
      onOptionSelect,
      placeholder,
      dependentField,
      change,
      defaultValue,
      disabled,
      scrollable,
      menuMaxHeight
    } = this.props;
    const normalizedOptions = (options || []).map(option => (
      option.sub_type
        ? {
          label: option.label,
          options: (option.sub_types || []).map(groupOption => ({
            value: groupOption.value,
            label: groupOption.label
          }))
        }
        : {
          value: option.value,
          label: option.label
        }
    ));
    const selectedOption = scrollable
      ? normalizedOptions
        .flatMap(option => (option.options ? option.options : [option]))
        .find(option => String(option.value) === String(value))
      : null;
    const scrollableStyles = {
      control: (base, state) => ({
        ...base,
        minHeight: '40px',
        height: '40px',
        borderColor: '#cecece',
        borderStyle: 'double',
        borderWidth: 'thin',
        boxShadow: 'none',
        borderRadius: base.borderRadius,
        backgroundColor: disabled ? '#f9f9f9' : '#fff',
        fontSize: '12px',
        fontWeight: 'bold',
        fontFamily: "Roboto,-apple-system,BlinkMacSystemFont,'Helvetica Neue',Helvetica,sans-serif",
        '&:hover': {
          borderColor: '#cecece'
        },
        opacity: state.isDisabled ? 0.6 : 1
      }),
      valueContainer: base => ({
        ...base,
        padding: '5px 10px'
      }),
      singleValue: base => ({
        ...base,
        color: '#253858',
        fontSize: '12px',
        fontWeight: 'bold',
        fontFamily: "Roboto,-apple-system,BlinkMacSystemFont,'Helvetica Neue',Helvetica,sans-serif"
      }),
      placeholder: base => ({
        ...base,
        color: '#aaa',
        fontSize: '12px',
        fontWeight: 'bold',
        fontFamily: "Roboto,-apple-system,BlinkMacSystemFont,'Helvetica Neue',Helvetica,sans-serif"
      }),
      input: base => ({
        ...base,
        color: '#253858',
        fontSize: '12px',
        fontWeight: 'bold',
        fontFamily: "Roboto,-apple-system,BlinkMacSystemFont,'Helvetica Neue',Helvetica,sans-serif"
      }),
      indicatorSeparator: base => ({
        ...base,
        display: 'none'
      }),
      menuPortal: base => ({ ...base, zIndex: 9999 }),
      menu: base => ({ ...base, zIndex: 9999 }),
      menuList: base => ({
        ...base,
        maxHeight: `${menuMaxHeight || 220}px`,
        overflowY: 'auto'
      }),
      option: (base, state) => ({
        ...base,
        fontSize: '12px',
        fontWeight: 'bold',
        fontFamily: "Roboto,-apple-system,BlinkMacSystemFont,'Helvetica Neue',Helvetica,sans-serif",
        backgroundColor: state.isFocused ? '#ebf5ff' : '#fff',
        color: '#666666'
      })
    };

    if (scrollable) {
      return (
        <Select
          className={className}
          classNamePrefix="Select"
          options={normalizedOptions}
          placeholder={placeholder}
          value={selectedOption || null}
          isDisabled={disabled}
          maxMenuHeight={menuMaxHeight || 220}
          menuPlacement="auto"
          menuShouldScrollIntoView={false}
          menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
          styles={scrollableStyles}
          onChange={selected => {
            const nextValue = selected ? selected.value : '';
            onChange(nextValue);
            onOptionSelect && onOptionSelect(nextValue);
            if (dependentField) {
              change(dependentField, null);
            }
          }}
        />
      );
    }

    return (
      <select
        className={`Select-input select-input-font ncss-input pt2-sm pr4-sm pb2-sm pl4-sm ${className}`}
        defaultValue={defaultValue}
        value={value === '' ? defaultValue : value}
        size={1}
        onChange={e => {
          onChange(e.target.value);
          onOptionSelect && onOptionSelect(e.target.value);
          if (dependentField) {
            change(dependentField, null);
          }
        }}
        selected={defaultValue}
        disabled={disabled}
      >
        <option value='' hidden>{placeholder}</option>
        {options.map(option => (
          option.sub_type?
          <optgroup label={option.label}>
             {option.sub_types.map(group_option => (
            <option value={group_option.value} key={group_option.id}>{group_option.label}</option>
             ))}
          </optgroup>:
          <option value={option.value} key={option.id} { ...((option.value && value && option.value.toString() === value.toString()) && {'is-selected' : 'true'}) }>
            {option.label}
          </option>
        ))}
      </select>
    );
  }
}
const CustomDropDown = ({ input, options, className, name, placeholder, dependentField, change, onOptionSelect, disabled, scrollable, menuMaxHeight }) => (
  <DropDown
    {...input}
    options={options}
    name={name}
    placeholder={placeholder}
    className={className}
    value={input.value}
    onChange={input.onChange}
    { ...( onOptionSelect && {onOptionSelect: onOptionSelect}) }
    dependentField={dependentField}
    change={change}
    disabled={disabled}
    scrollable={scrollable}
    menuMaxHeight={menuMaxHeight}
  />
);
DropDown.propTypes = {
  options: PropTypes.array,
  className: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  dependentField: PropTypes.string,
  change: PropTypes.func,
  defaultValue: PropTypes.number,
  disabled: PropTypes.bool,
  scrollable: PropTypes.bool,
  menuMaxHeight: PropTypes.number
};
export default CustomDropDown;
